<template>
  <div class="news">
    <h2>{{ $t('media.description') }}</h2>
    <div class="wrapper">
      <div class="gallery">
        <div data-aos="fade-up" :data-aos-delay="100" v-for="(photo, index) in this.photos" :key="index">
          <img class="image" :src="photo.source_url" @click="openModal(index)" />
        </div>
        <vs-popup
          :title="`${activeIndex + 1} / ${photos.length}`"
          :active.sync="isModalOpen"
        >
          <div class="popup-inner">
            <div class="gallery-popup">
              <div class="popup-btn left" :class="{ disable: activeIndex === 0 }" @click="changePhoto(activeIndex - 1)">
                <i class="chevron left"></i>
              </div>
              <div class="gallery-inner">
                <div v-for="(photo, index) in photos" :key="index" :class="getClass(index)">
                  <img :src="photo.source_url" />
                </div>
              </div>
              <div
                class="popup-btn right"
                :class="{ disable: activeIndex === photos.length - 1 }"
                @click="changePhoto(activeIndex + 1)"
              >
                <i class="chevron right"></i>
              </div>
            </div>
          </div>
        </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    photos: Array.from({ length: 18 }, (_, i) => ({
      source_url: `static/img/gallery/photo${i + 1}.jpg`
    })),
      activeIndex: 0,
      isModalOpen: false,
    };
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleKeydown(event) {
      if (this.isModalOpen) {
        switch (event.key) {
          case 'ArrowLeft':
            this.changePhoto(this.activeIndex - 1);
            break;
          case 'ArrowRight':
            this.changePhoto(this.activeIndex + 1);
            break;
          case 'Escape':
            this.closeModal();
            break;
          }
      }
    },
    openModal(index) {
      this.changePhoto(index);
      this.isModalOpen = true;
    },
    changePhoto(index) {
      if (index >= 0 && index < this.photos.length) {
        this.activeIndex = index;
      }
    },
    closeModal() {
      this.isModalOpen = false;
    },
    getClass(index) {
      return {
        'gallery-item': true,
        active: index === this.activeIndex,
        prevItem: index < this.activeIndex,
        nextItem: index > this.activeIndex,
      };
    },
  },
};
</script>

<style scoped>
.news {
  margin-top: -100px;
  text-align: center;
}

h2 {
  margin-bottom: 33px;
}
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.gallery {
  column-count: 3;
  column-gap: 1rem;
}

.image {
  width: 100%;
  display: block;
  margin-bottom: 1rem;
  cursor: pointer;
  transition: all 0.4s;
  max-width: 380px;
  break-inside: avoid;
  object-fit: cover;
}
.image:hover {
  animation: point 0.4s;
}

.popup-btn {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  height: 100%;
  width: 80px;
  top: 0;
box-shadow: inset 0px 33px 25px 0 #000, 
}

.popup-btn.left {
  position: absolute;
  left: 0;
}
.popup-btn.right {
  position: absolute;
  right: 0;
}

.gallery-inner {
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
}

.gallery-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  transition: 0.3s ease-in-out;
  -webkit-transition: 0.3s ease-in-out;
}
.gallery-item img {
  max-width: 100%;
  max-height: 75vh;
  object-fit: contain;
}

.active {
  transform: translateX(0);
}
.prevItem {
  margin-left: -100%;
  transform: translateX(-100%);
}
.nextItem {
  margin-right: -100%;
  transform: translateX(100%);
}

.con-vs-popup {
  z-index: 53000;

  .vs-popup {
    width: 1000px !important;
    height: 800px !important;
  }
  .vs-popup--close {
    transition: none !important;
    transform: none !important;
    background: none !important;
    box-shadow: none !important;
  }
  .vs-popup--close:hover {
    color: #383838 !important;
  }
  .vs-popup--content {
    width: auto !important;
    padding: 1rem;
    font-size: 1rem;
    height: 95%;
    display: flex;
    justify-content: center;
  }
}
.popup-inner {
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup-btn .chevron::before {
  color: rgb(167, 167, 167);
}
.popup-btn:hover .chevron::before {
  color: rgb(111, 111, 111);
}
.disable {
  pointer-events: none;
  opacity: 0.3;
}

.chevron::before {
  border-style: solid;
  border-width: 0.25em 0.25em 0 0;
  content: '';
  display: inline-block;
  height: 1.45em;
  width: 1.45em;
  position: relative;
  top: 0.15em;
  color: rgba(255, 255, 255, 0.6);
  transform: rotate(-45deg);
  vertical-align: top;
}

.chevron.right:before {
  transform: rotate(45deg);
}

.chevron.left:before {
  transform: rotate(-135deg);
}
@media (max-width: 1200px) {
  .gallery {
    column-count: 2;
  }
}
@media (max-width: 786px) {
  .gallery {
    column-count: 1;
  }
}

@keyframes point {
  50% {
    transform: scale(0.97, 0.97);
    -ms-transform: scale(0.97, 0.97);
    -webkit-transform: scale(0.97, 0.97);
  }
  100% {
    transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
  }
}
</style>



// WEBPACK FOOTER //
// MediaBox.vue?32c7fdf0